import dayjs from "dayjs";
import orderBy from "lodash/orderBy";

import type { ProjectsResponseSchema } from "app/pages/activation/types/api";

export const getSortedProjects = (data: ProjectsResponseSchema) => {
    const sortedProjects = orderBy(
        data.activationSets,
        ["isFavorite", "isOwn", ({ lastUpdated }) => dayjs(lastUpdated).valueOf()],
        ["desc", "desc", "desc"],
    );

    return {
        ...data,
        activationSets: sortedProjects,
    };
};
